module.exports = __webpack_public_path__ + "img/team-max-krause@2x.b0f43a80.jpg";